<script>
    import {
        unsetPrivateAnalyzeHandler,
        changeHandlerPassword,
        addAccount, updateHandler
    } from "../lib/ApiRequests.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import {onDestroy, onMount} from "svelte";
    import {_} from '../lib/i18n';

    export let handler;
    export let handlers;
    export let analyzes = [];

    export let showEdit = false;
    export let showDelete = false;

    let isLoading = false;

    let photo;
    $: photo = handler ? '/account/avatar?id='+handler.id : '';
    let username;
    $: username = handler ? handler.username : '';
    let login = handler ? handler.login : '';
    let password = '';

    let error = '';

    onMount(() => {

    });

    onDestroy(() => {

    });


    function toggleEditForm() {
        showEdit = !showEdit;
    }

    function toggleDeleteForm() {
        showDelete = !showDelete;
    }

    function hideDeleteForm() {
        showDelete = false;
    }

    let deleteInProgress = false;
    async function deleteHandler() {
        deleteInProgress = true;

        try {
            const response = await unsetPrivateAnalyzeHandler(handler.id)
        } catch (e) {
            console.log(e.message);
        }
        handlers = handlers.filter((item) => {return item.id !== handler.id});
        analyzes = analyzes.map((analyze) => {
            if (analyze.handler && analyze.handler.id === handler.id) {
                analyze.handler = null;
            }
            return analyze;
        });

        showEdit = false;
        showDelete = false;
        deleteInProgress = false;
    }

    async function reSetHandler() {
        isLoading = true;

        if (handler.login === login) {
            const changePasswordResponse = await changeHandlerPassword(handler.id, password);
            if (changePasswordResponse.status === 'ok') {
                analyzes = analyzes.map((analyze) => {
                    if (analyze.handler && analyze.handler.id === handler.id) {
                        analyze.isPasswordError = false;
                        analyze.handler.password = password;
                    }
                    return analyze;
                });
            }
        } else {
            const newHandler = {
                login,
                password
            }
            const addAccountResponse = await addAccount(newHandler.login, newHandler.password);
            if (addAccountResponse.result !== 'ok') {
                // здесь можно отобразить ошибку, но в макете её нет
            } else {
                const setHandlerResponse = await updateHandler(handler.id, addAccountResponse.id);
                if (setHandlerResponse.status === 'ok') {
                    newHandler.id = addAccountResponse.id;
                    newHandler.username = addAccountResponse.username;
                    newHandler.login = addAccountResponse.login;
                    newHandler.account_avatar = addAccountResponse.avatar;
                    newHandler.is_not_friend = false;
                    newHandler.isPasswordError = false;
                    analyzes = analyzes.map((analyze) => {
                        if (analyze.handler && analyze.handler.id === handler.id) {
                            analyze.isPasswordError = false;
                            analyze.handler = newHandler;
                        }
                        return analyze;
                    });
                    handler = newHandler;
                }
            }
        }

        isLoading = false;
        showEdit = false;
        showDelete = false;
    }

    function onImageError(event) {
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }
</script>


<div class="target-item">
{#if username}
    <div class="target-item__header">
        <div class="target-item__header-wrapper">
            <img src={photo} alt="avatar" class="target-item__avatar" on:error={onImageError} />
            <div class="target-item__info">
                <p class="target-item__label">{$_('settingHandlerInfo.accountLabel')}:</p>
                <div class="target-item__name">@{username}</div>
            </div>
        </div>

        <button class="button button_textual" on:click={toggleEditForm}>
            {$_('settingHandlerInfo.editButtonLabel')}
        </button>
    </div>

    {#if showEdit}
    <section class="private-acc-block system-info system-info_yellow" id="handler-edit-form">
        <div class="private-acc-block__title-wrapper system-info__title-wrapper">
            <div class="private-acc-block__title-icon system-info__title-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.3156 7.04081L7.5412 14.8153C7.262 15.0945 6.90639 15.2848 6.51921 15.3622L4.16673 15.8327L4.63723 13.4802C4.71466 13.0931 4.90497 12.7375 5.18417 12.4583L12.9586 4.68378M15.3156 7.04081L16.3762 5.98015C16.7668 5.58962 16.7668 4.95646 16.3762 4.56593L15.4334 3.62312C15.0429 3.2326 14.4097 3.2326 14.0192 3.62312L12.9586 4.68378M15.3156 7.04081L12.9586 4.68378" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <h3 class="private-acc-block__title-text system-info__title-text">Изменение данных</h3>
        </div>
        <p class="private-acc-block__text system-info__text">
            {@html $_('settingHandlerInfo.editFormDescription', {
                values: { username: username, },
            })}
        </p>
        <div class="private-acc-block__form form">
            <input type="text" class="private-acc-block__input general-input" placeholder={$_('settingHandlerInfo.loginPlaceholder')} bind:value={login} />
            <input type="password" class="private-acc-block__input general-input" placeholder={$_('settingHandlerInfo.passwordPlaceholder')} bind:value={password} />
            <button class="button button_ghost private-acc-block__form-btn"
                    on:click={reSetHandler}>
                <LoadingIcon show={isLoading} width="16" height="16"/>
                {$_('settingHandlerInfo.updateHandler')}
            </button>
        </div>
        {#if !showDelete}
            <button class="button button_textual button_delete_handler" on:click={toggleDeleteForm}>
                {$_('settingHandlerInfo.deleteHandlerButton')}
            </button>
        {/if}
        {#if showDelete}
        <div class="target-item__delete-title-wrapper system-info__title-wrapper">
            <div class="target-item__delete-title-icon system-info__title-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="9.99935" cy="14.1667" rx="0.833333" ry="0.833333" fill="#C93329" />
                    <path d="M10 8.33334L10 11.6667" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.11323 14.6056L8.21049 4.41105C8.94754 2.93695 11.0512 2.93695 11.7882 4.41105L16.8855 14.6056C17.5504 15.9354 16.5834 17.5 15.0966 17.5H4.90208C3.41532 17.5 2.44833 15.9354 3.11323 14.6056Z" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <h3 class="target-item__delete-title-text system-info__title-text">{$_('settingHandlerInfo.targetDeletionBlockTitle', {
                values: { username },
            })}</h3>
        </div>
        <p class="target-item__delete-text system-info__text">{@html $_('settingHandlerInfo.deleteFormHandlerDescription', {
            values: { username },
        })}</p>
        <div class="target-item__delete-controls-wrapper system-info__controls-wrapper">
            <div class="button button_ghost system-info__controls-btn system-info__controls-btn_main target-item__delete-btn target-item__delete-btn_main" on:click={hideDeleteForm}>
                {$_('settingHandlerInfo.cancelDelete')}
            </div>
            <div class="button button_textual system-info__controls-btn system-info__controls-btn_secondary target-item__delete-btn target-item__delete-btn_secondary"
                 on:click={deleteHandler}>
                <LoadingIcon show={deleteInProgress} height="16" width="16" color="#161516" />
                {$_('settingHandlerInfo.confirmDelete')}
            </div>
        </div>
        {/if}
    </section>
    {/if}
{/if}
</div>


<style>
    .target-item__avatar {
        border-radius: 100%;
    }
    .button_delete_handler {
        color: #000000;
        padding: 10px 0;
        text-align: left;
    }
    .target-item__delete-btn {
        padding: 12px 24px 11px 24px;
    }
    .target-item__delete-btn_secondary {
        text-decoration: underline;
    }
    .target-item__delete-title-text {
        color: #C93329;
    }

</style>